import filter from '@/js/util/symbols/filter'
import propsTag from '@/js/util/props/propsTag'

// this component is for pulling data from the provider and passing it thorugh a slot

export default {
  name: 'BaseFilterDispatch',
  inject: { filter },
  props: { ...propsTag },

  render(createElement) {
    const {
      title,
      checked,
      filtered,
      showModal,
      amountShown,
      checkedTitles,
      checkedTitlesData,
    } = this.filter
    const { length } = checkedTitles
    const dispatchedData = {
      title,
      length,
      checked,
      filtered,
      showModal,
      amountShown,
      checkedTitles,
      checkedTitlesData,
    }
    return createElement(this.tag, this.$scopedSlots.default(dispatchedData))
  },
}



// WEBPACK FOOTER //
// ./src/js/components/BaseFilterDispatch.js